import { Blockchain } from "@anaconda/core/blockchain/types"
import type { Nft, NftStandard } from "@anaconda/core/nft/types"

const LABELS: Record<NftStandard, string> = {
  MPL_CORE: "MPL Core",
  METAPLEX: "Metaplex",
  TOKEN2022: "Token-2022",
  WNS: "Wrapped NFT Standard",
  BUBBLEGUM: "Bubblegum (cNFT)",
}

export const getTokenStandardLabel = (nft: Nft): string | undefined => {
  if (nft.nftStandard) return LABELS[nft.nftStandard]
  // Solana's collection.type is generic after the indexer fix and wrong before it, so it is
  // never a usable fallback there. Other chains keep their existing label verbatim.
  if (nft.collection.blockchain === Blockchain.SOLANA) return undefined
  return nft.collection.type?.replaceAll("_", "-")
}
